export default __webpack_public_path__ + "static/media/appStore.c5806727.svg";